export default Object.freeze({
  Password: 1,
  PrivateKeyFile: 2,
});
